const onEnter = [
  'stateSession',
  'ProductService',
  '$state',
  (
    stateSession,
    ProductService,
    $state,
  ) => {
    if (!ProductService.isAvailable('PATIENT_ARRIVAL_KIOSK')) {
      $state.go('not_found');
    }
  },
];

module.exports = ['$stateProvider', $stateProvider =>

$stateProvider
  .state('kiosk', {
    url: '/kiosk',
    abstract: true,
    parent: 'root',
    views: {
      '@': {
        template: `
          <div ui-view="content"></div>
        `,
      },
    },
    onEnter,
  })
  .state('kiosk.login', {
    insecure: true,
    parent: 'root',
    url: '/kiosk/login',
    views: {
      'content@root': {
        template: '<login class="patient-bg" mode="kiosk">',
      },
    },
    onEnter,
  })
  .state('kiosk.home', {
    url: '/home',
    views: {
      'content@kiosk': {
        template: `
          <layout-box>
            <app-header></app-header>
            <kiosk-home></kiosk-home>
            <kiosk-footer></kiosk-footer>
          </layout-box>
        `,
      },
    },
    onEnter,
  })
  .state('kiosk.appointments', {
    url: '/appointments',
    views: {
      'content@kiosk': {
        template: `
          <layout-box>
            <app-header></app-header>
            <kiosk-appointments></kiosk-appointments>
            <kiosk-footer></kiosk-footer>
          </layout-box>
        `,
      },
    },
    onEnter,
  })
  .state('kiosk.informations', {
    url: '/informations',
    views: {
      'content@kiosk': {
        template: `
          <layout-box>
            <app-header></app-header>
            <kiosk-informations></kiosk-informations>
            <kiosk-footer></kiosk-footer>
          </layout-box>
        `,
      },
    },
    onEnter,
  })
  .state('kiosk.error', {
    url: '/error',
    views: {
      'content@kiosk': {
        template: `
          <layout-box>
            <app-header></app-header>
            <kiosk-error></kiosk-error>
            <kiosk-footer></kiosk-footer>
          </layout-box>
        `,
      },
    },
    onEnter,
  })];



// WEBPACK FOOTER //
// ./kiosk/config/routes.js